import { render, staticRenderFns } from "./DesignRenewalForm.vue?vue&type=template&id=cb0fb048&"
import script from "./DesignRenewalForm.vue?vue&type=script&lang=js&"
export * from "./DesignRenewalForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignRenewalForm.vue?vue&type=style&index=0&id=cb0fb048&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports